export default (str) => (
  // match camelCase or 'space separated' strings
  str.replace(/([a-z])(?:([A-Z])|(?:[- ]+)(\w))/g, (g, g1, g2, g3) =>
    `${g1}-${(g2 || g3).toLowerCase()}`
  )
);
